import { useCallback, useEffect } from "react";
import apiClient from "../api/api-client";
import useAsync from "../hooks/use-async";

export default function useFacebookTokens() {
    const { data, isIdle, isPending, isError, isSuccess, run } = useAsync();

    useEffect(() => {
        reload();
    }, []);

    const reload = useCallback(() => run(apiClient("facebook-tokens")).catch(() => { }));

    return {
        tokens: data?.data, 
        isPending: isIdle || isPending,
        isError,
        isSuccess,
        reload,
    };
}